import { render, staticRenderFns } from "./ModernCardAula.vue?vue&type=template&id=78efeef9&scoped=true"
import script from "./ModernCardAula.vue?vue&type=script&lang=js"
export * from "./ModernCardAula.vue?vue&type=script&lang=js"
import style0 from "./ModernCardAula.vue?vue&type=style&index=0&id=78efeef9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78efeef9",
  null
  
)

export default component.exports